module.exports = __webpack_public_path__ + "icon_lamp.58430fc5868535aaee0e1715c4250495.svg";